import ContentLoader from 'react-content-loader';

const PriceAlertsPlaceholders = (): JSX.Element => {
  return (
    <div
      style={{
        backgroundColor: '#fff',
        width: '100%',
      }}
    >
      <ContentLoader
        speed={4}
        width="100%"
        height={102}
        backgroundColor="#EFF2F5"
        foregroundColor="#FFFFFF"
      >
        <rect x="24" rx="4" ry="3" y="20" height="16" width="15%" />
        <rect x="92%" rx="4" ry="3" y="20" height="16" width="40px" />
        <rect x="24" rx="4" ry="3" y="45" height="16" width="80%" />
        <rect x="24" rx="4" ry="3" y="70" height="16" width="18%" />
      </ContentLoader>
    </div>
  );
};

export default PriceAlertsPlaceholders;
